var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-panel" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "znj-box flex" },
        _vm._l(_vm.spList, function (item, i) {
          return _c("div", { key: i, staticClass: "jxh-item zzy-item" }, [
            _c("p", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
            _c("p", { staticClass: "fl-name" }, [
              _vm._v(" " + _vm._s(item.name) + " "),
              item.unit
                ? _c("span", [_vm._v("(" + _vm._s(item.unit) + ")")])
                : _vm._e(),
            ]),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "nyjx-box flex" },
        _vm._l(_vm.mjList, function (item, i) {
          return _c("div", { key: i, staticClass: "jxh-item znj-item" }, [
            _c("p", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
            _c("p", { staticClass: "fl-name" }, [_vm._v(_vm._s(item.name))]),
            item.unit
              ? _c("p", [_vm._v("(" + _vm._s(item.unit) + ")")])
              : _vm._e(),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }